import React, { FC } from 'react';
import Column from 'shared/components/atoms/Column';
import { useSelector } from 'react-redux';
import { selectOrderAddress } from 'Order/selectors';
import { selectQuote, selectSelectedPrice } from 'Quotes/selectors';
import { presentSupplierName } from 'Quotes/utils/supplierHelpers';
import { Supplier } from 'Quotes/types/supplier';
import { PoP } from '../PoP';

export const OpticalP2P: FC<React.PropsWithChildren<unknown>> = () => {
  const { A, B } = useSelector(selectOrderAddress);
  const quote = useSelector(selectQuote);
  const selectedPrice = useSelector(selectSelectedPrice);

  return (
    <>
      <div className="row no-gutters mt-3">
        <Column defaultWidth={2}>
          <span className="sub-heading">Location(s)</span>
        </Column>
        <Column defaultWidth={2}>
          <span className="font-weight-bold">
            A-End { selectedPrice.a_end_access_type !== Supplier.NONE ?
             `(${presentSupplierName(selectedPrice.a_end_access_type || '')})` : ''
            }
          </span>
        </Column>
        <Column defaultWidth={8}>
          <address className="mb-0" data-testid="order-summary-op2p-a-end-address">
            {A}
          </address>
          {selectedPrice.a_end_access_type !== Supplier.NONE && <PoP
            end="A"
            port={quote.aEndPort}
            pop={selectedPrice.a_end_p_o_p}
            postcode={selectedPrice.a_end_p_o_p_postcode}
            exchangeType={selectedPrice.a_end_exchange_type}
            showExchange={true}
          />}
        </Column>
      </div>
      <div className="row no-gutters mt-3">
        <Column defaultWidth={2} offsetDefaultWidth={2}>
          <span className="font-weight-bold">
            B-End { selectedPrice.b_end_access_type === Supplier.OPENREACH ?
             `(${presentSupplierName(selectedPrice.b_end_access_type || '')})` : ''
            }
          </span>
        </Column>
        <Column defaultWidth={8}>
          <address className="mb-0" data-testid="order-summary-op2p-b-end-address">
            {B}
            {selectedPrice.b_end_access_type === Supplier.OPENREACH && <PoP
              end="B"
              port={quote.bEndPort}
              pop={selectedPrice.b_end_p_o_p}
              postcode={selectedPrice.b_end_p_o_p_postcode}
              exchangeType={selectedPrice.b_end_exchange_type}
              showExchange={true}
            />}
          </address>
        </Column>
      </div>
    </>
  );
};
